'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './app-config.routes';

export class AppConfigEditorComponent {

  constructor($uibModal, SettingsService, dialogs, $scope, prompt, Config, $window) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;
    this.$scope = $scope;
    this.prompt = prompt;
    this.$window = $window;

    this.defaultMenuPermission = Config.getPlatformConfig().getMenuDefaultPermission();

    SettingsService.getByName({name: 'config.app'}, setting => {
      this.setting = setting;
      this.appConfig = setting.data;
    });

    this.settings = {
      'frontpage': ['classic',"fullslider","video","pageonly"]
    };

    this.linkCategories = [
      {
        "name" : "General", "description":"Lorem ipsum",
        "children" : [
          { "id": "dir.numbers", "name" : "Important Numbers", "description" : "A list with important numbers", "children" : [] },
          { "id": "dir.users", "name" : "User Directory", "description" : "A directory with all the registered users and their profiles", "children" : [] },
          { "id": "dir.businesses", "name" : "Business Directory", "description" : "A directory with all the resident business profiles which have been created by the users", "children" : [] },
          { "id": "dir.vendors", "name" : "Preferred Vendors List", "description" : "An admin created and managed directory of vendors", "children" : [] },
          { "id": "dir.directory", "name" : "Generic Person Directory", "description" : "An directory with name, function, a profile image, contact information and a short description. Possible use-cases include Board of Directories and Staff.", "children" : [] }
        ]
      },
      {
        "name": "Frontpage", "description": "",
        "id": "frontpage",
        "children": [

        ]
      },
      {
        "name": "Document", "description": "",
        "children": [

        ]
      },
      {
        "name": "Directories", "description": "",
        "children": [

        ]
      },
      {
        "name": "Calendar", "description": "",
        "children": [

        ]
      },
      {
        "name": "Gallery", "description": "",
        "children": [

        ]
      },
      {
        "name": "Forum", "description": "",
        "children": [

        ]
      },
      {
        "name": "News", "description": "",
        "children": [

        ]
      },
      {
        "name": "Bulletin Board", "description": "",
        "children": [

        ]
      },
      {
        "name": "SignUp", "description": "",
        "children": [

        ]
      },
      {
        "name": "Profile", "description": "",
        "children": [

        ]
      },
      {
        "name": "Mailblast", "description": "",
        "children": [

        ]
      },
      {
        "name": "Reservation", "description": "",
        "children": [

        ]
      }

    ];
  }

  openMenuEntryEditor(menuEntry) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'lg',
      component: 'menuEntryEdit',
      resolve: {
        config: function() {
          return {
            public: that.public,
            menuEntry: menuEntry
          }
        }
      }
    });

    modalInstance.result.then(
      function () {
       //todo: ddd

      },
      function () { /* cancel */ }
    );

  }

  save() {
    this.setting.data = this.slider;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The menu has been updated successfully");
      //then:  this.$window.location.reload();
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.appConfigEditor', [uiRouter])
  .config(routes)
  .component('appConfigEditor', {
    template: require('./app-config.html'),
    controller: AppConfigEditorComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/app-config/app-config.component.js